"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SORT_DIRECTION = void 0;
exports.castValueForSorting = castValueForSorting;
exports.sortData = sortData;
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var SORT_DIRECTION = {
  "Ascending": "Ascending",
  "Descending": "Descending"
};
exports.SORT_DIRECTION = SORT_DIRECTION;
function castValueForSorting(fieldValue) {
  var dateTimeStringRegex = /^\d{4}-\d{2}-\d{2}T\d.*/;
  if (new RegExp(dateTimeStringRegex).test(fieldValue)) {
    return new Date(fieldValue);
  }
  var type = _typeof(fieldValue);
  switch (type) {
    case "string":
      return fieldValue.toUpperCase();
    case "number":
      return Number(fieldValue);
    default:
      return fieldValue ? fieldValue.toString() : '';
  }
}
function sortData(items, fieldName, sortDirection) {
  return items.sort(function (a, b) {
    var itemA = castValueForSorting(a[fieldName]);
    var itemB = castValueForSorting(b[fieldName]);
    if (sortDirection === SORT_DIRECTION.Ascending) {
      if (itemA < itemB) {
        return -1;
      }
      if (itemA > itemB) {
        return 1;
      }
    }
    if (sortDirection === SORT_DIRECTION.Descending) {
      if (itemA > itemB) {
        return -1;
      }
      if (itemA < itemB) {
        return 1;
      }
    }
    return 0;
  });
}